// extracted by mini-css-extract-plugin
export var active = "Mode-module--active--e303b";
export var btn = "Mode-module--btn--b3968";
export var dark = "Mode-module--dark--00fe4";
export var darkMode = "Mode-module--dark-mode--72d6b";
export var grey = "Mode-module--grey--ec2c0";
export var greyMode = "Mode-module--grey-mode--71caa";
export var light = "Mode-module--light--d7c6d";
export var padded = "Mode-module--padded--9e9b8";
export var toggleWrapper = "Mode-module--toggle-wrapper--a5ee8";